export const getInvitationWorkspaceRole = (invitation) =>
  invitation?.workspace_role ||
  invitation?.workspaceRole ||
  invitation?.role ||
  "admin_limitado";

const resolveBaseUrl = (baseUrl = "") => {
  if (baseUrl) {
    return baseUrl.replace(/\/$/, "");
  }

  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin.replace(/\/$/, "");
  }

  return "";
};

export const buildInvitationRegistrationUrl = (invitation, baseUrl = "") => {
  const resolvedBaseUrl = resolveBaseUrl(baseUrl);
  const params = new URLSearchParams();
  const email = String(invitation?.email || "").trim().toLowerCase();
  const workspaceRole = String(getInvitationWorkspaceRole(invitation) || "").trim();
  const invitationToken = String(invitation?.invitation_token || "").trim();

  params.set("register", "1");

  if (email) {
    params.set("email", email);
  }

  if (workspaceRole) {
    params.set("role", workspaceRole);
  }

  if (invitationToken) {
    params.set("invite", invitationToken);
  }

  return `${resolvedBaseUrl}/login?${params.toString()}`;
};

export const buildInvitationPasswordSetupUrl = (invitation, baseUrl = "") => {
  const resolvedBaseUrl = resolveBaseUrl(baseUrl);
  const params = new URLSearchParams();
  const email = String(invitation?.email || "").trim().toLowerCase();
  const workspaceRole = String(getInvitationWorkspaceRole(invitation) || "").trim();
  const invitationToken = String(invitation?.invitation_token || "").trim();

  params.set("setup", "1");

  if (email) {
    params.set("email", email);
  }

  if (workspaceRole) {
    params.set("role", workspaceRole);
  }

  if (invitationToken) {
    params.set("invite", invitationToken);
  }

  return `${resolvedBaseUrl}/recuperar-contrasena?${params.toString()}`;
};

export const copyTextToClipboard = async (text) => {
  if (!text) {
    return false;
  }

  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return true;
  }

  if (typeof document === "undefined") {
    return false;
  }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "true");
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  textarea.style.pointerEvents = "none";
  document.body.appendChild(textarea);
  textarea.select();
  textarea.setSelectionRange(0, textarea.value.length);
  const copied = document.execCommand("copy");
  document.body.removeChild(textarea);
  return copied;
};
